import React, {useEffect} from "react"
import classNames from "classnames"
import moment from "moment"
import useOpenCourses from "hooks/useOpenCourses"
import useCourseTypes from "hooks/useCourseTypes"
import useLocations from "hooks/useLocations"
import {plural} from "utils"
import {saturday} from "dates"
import "./Steps.css"


export default function Step1(props) {

    const {selectCourses, getNext, getPrice} = useOpenCourses()
    const {getType} = useCourseTypes()
    const {getLocation} = useLocations()
    const {invalid, data, update} = props


    useEffect(() => {
        if (selectCourses && selectCourses.length === 1) update('courseId', selectCourses[0].id)
        else update('courseId', '')
    }, [selectCourses, update])
                   
    
    return <section className="step" id="step-1">
        <div className="step-label">Step 1 of 5</div>
        <h2>Your course</h2>        
        <p>Please select the course you want to attend</p>
        
        <div className="inputs">
            
            {invalid.includes('courseId') && <div className="please-select">Please select</div>}
            
            <div id="courses">
                {selectCourses?.map(course => [course, getNext(course.id), getType(course.type)])
                    .map(([course, next, courseType]) => [course, next, courseType, getLocation(course.location), getLocation(next?.location)])
                    .map(([course, next, courseType, location, nextLocation]) => <button key={course.id} className={classNames("course", {selected: course.id === data.courseId})} onClick={e => update('courseId', course.id)}>
                        <div className="name">{courseType?.name}</div>
                        
                        <div className="columns">
                                                        
                            {next?.week ? <>
                                <div>Duration:</div><div>{courseType?.weeks} {plural('week', courseType?.weeks)}</div>
                                <div>Week 1:</div>
                                <div>Starting {moment(saturday(course.week, course.year)).format("LL")}<br/>
                                from {location?.city}, {location?.country}</div>
                                <div>Week 2:</div><div>Starting {moment(saturday(next.week, course.year)).format("LL")}<br/>
                                from {nextLocation?.city}, {nextLocation?.country}</div>
                                <div>Price:</div><div>{getPrice(course)} EUR</div>
                            </> : <>
                                <div className="span-2">Duration: {courseType?.weeks} {plural('week', courseType?.weeks)}</div>
                                <div className="span-2">Starting {moment(saturday(course.week, course.year)).format("LL")}<br/>
                                from {location?.city}, {location?.country}</div>
                                <div className="span-2">Price: {getPrice(course)} EUR</div>
                            </>}
                            
                        </div>
                    </button>)
                }
            </div>
        </div>
    </section>
}